import {Component} from "react";
import React from "react";
import { Link } from 'react-router-dom'
import moment from 'moment';
import Gallery from "../Modal/Gallery";
import SVG from "react-inlinesvg";
import modalIcon from "../../assets/modal_icon.svg";
import $ from "jquery";
import ToolTips from "../Shared/ToolTips";
import whiteStar from "../../assets/Star-white@3x.png";

class UnitRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            units: [],
            showModal: {
                gallery: false
            },
            gallery_id: false
        }
        this.myRef = React.createRef()
    }
    toggleModal = (type, show) => {
        this.setState({
            showModal: {
                [type]: show
            }
        })
    };
    galleryInfo = (id) => {
        this.setState({
            gallery_id: id
        })
    }
    filterFuncs = () => {
        let filtered = this.props.unit.functionalities.filter((f, i) => {
            if(f.name !== "Expandable" && f.name !== "Interstitial"){
                return f;
            }
        })
        return(
            <td>{filtered.map(f => f.name).join(', ')}</td>
        )
    }
    ifBulk = () => {
        return this.props.unit.display_banner_type === "standard" || this.props.unit.creative_type === "Video";
    }
    render() {
        const { unit } = this.props;
        return (
            <React.Fragment>
                {this.state.showModal.gallery && <Gallery
                    toggleModal={this.toggleModal}
                    unit={unit}
                    active_id={this.state.gallery_id}
                    gallery_Info={this.galleryInfo}
                />}
                <tr>
                    <td className="creative-tr">
                            <Link to={`/${unit.unit_type}/${unit.id}`}>
                                <div className="campaign-image">
                                    {unit.unit_type === 'mock' && unit.animated === "true" ?  <span className="mocked-icon mocked-icon-btm-left"> </span> : <span className={`unit-type unit-type--${unit.unit_type} unit-type--bottom-left`}>{unit.unit_type}</span>}
                                    <img src={unit.thumbnail} alt={`unit-${unit.unit_type}-${unit.id}`}/>
                                </div>
                            </Link>
                        <div className="tool-wrapper">
                            {unit.favorite_id !== null ?
                                (<ToolTips content="Best in Class" data="bic">
                                  <span className="example-emoji" role="img" aria-label="cowboy emoji">
                                        <div style={ {background: "#e1ca6c", borderColor: "transparent"} } className="favorite-btn favorite-container"><img src={whiteStar} className="grey-star" alt=""/></div>
                                  </span>
                                </ToolTips>) : ""}
                        </div>
                    </td>
                    <td className="campaign-unit-type"><Link to={`/${unit.unit_type}/${unit.id}`}>{unit.creative_type}</Link></td>
                        {unit.creative_type === "Rich Media" || unit.creative_type === "Rich Media Expandable" || unit.creative_type === "Rich Media Interstitial" ? this.filterFuncs() :
                            <td>
                                {unit.functionalities.map(f => f.name).join(', ')}
                            </td>
                        }
                    <td>{unit.designer}</td>
                    <td>{moment(unit.date).format('MMMM YYYY')}</td>
                    <td className="links-container">
                        {unit.unit_type === 'live' &&
                            unit.demo_links.map((links, i) => {
                                if(i < 8) {
                                    return <div key={i}>
                                        <div className="tool-wrapper dl">
                                            <ToolTips content={links.name +" "+links.notes} data="device-labels">
                                                    <a className="device-link" key={i} href={links.url} target="_blank" rel="noopener noreferrer">{links.name}</a>
                                            </ToolTips>
                                        </div>
                                    </div>
                                }
                            })
                        }
                        {unit.unit_type === 'live' && this.ifBulk() === true &&
                            unit.s3_links.map((links, i) => {
                                if(i < 8) {
                                    return (
                                        <div key={i} id={links.id} onClick={(e) => {
                                            this.toggleModal('gallery', true);
                                            this.galleryInfo(links.id)
                                        }}>
                                            <div className="tool-wrapper dl">
                                                <ToolTips content={links.notes !== undefined ? links.ad_size +" "+ links.notes : links.ad_size } data="device-labels">
                                                     <span className="attached_links search-links">{links.ad_size}
                                                         <SVG src={modalIcon}/>
                                                     </span>
                                                </ToolTips>
                                            </div>
                                        </div>
                                    )
                                }
                            })
                        }
                        {unit.unit_type === 'live' && unit.demo_links.length > 8 || unit.s3_links.length > 8 &&
                            (<Link to={`/${unit.unit_type}/${unit.id}`}><span className="device-link" style={{textDecoration: 'underline'}}>view more...</span></Link>)
                        }
                        {unit.unit_type === 'mock' &&
                            <a className="device-link" href={unit.powerpoint} target="_blank" rel="noopener noreferrer">PowerPoint</a>
                        }

                    </td>
                </tr>
            </React.Fragment>
        )
    }
}

export default UnitRow;
